import type { StaticImageData } from "next/image";

// ROBOT_FOOT (use360Viewer) is measured off these renders; re-measure it
// when they change.
const FRAME_COUNT = 60;
const frames: string[] = [];

for (let i = 1; i <= FRAME_COUNT; i++) {
  const padded = i.toString().padStart(2, "0");
  const img: StaticImageData = require(
    `@assets/images/matic360/frame_${padded}.webp`,
  ).default;
  frames.push(img.src);
}

export default frames;
